import type { ForwardedRef } from "react";
import { forwardRef } from "react";
// eslint-disable-next-line boundaries/external
import { Link } from "react-router";

import { generateUrlWithLocale } from "~/i18n";
import type { UiKitLinkComponent, UIKitLinkProps } from "~/shared/ui-kit";

export const createLinkComponent = function (
  lang: LanguageCode,
): UiKitLinkComponent {
  return forwardRef<HTMLAnchorElement, UIKitLinkProps>(
    ({ children, href, ...rest }, ref: ForwardedRef<HTMLAnchorElement>) => {
      return (
        <Link {...rest} ref={ref} to={generateUrlWithLocale(href ?? "/", lang)}>
          {children}
        </Link>
      );
    },
  );
};
